$shm_hitalama_settings $mol_book2
	title \Настройки
	pages /
		<= Main $shm_hitalama_guide_page
			title \Настройки
			help_section \settings
			body <= main_content
		<= spread_current
	main_content /
		<= Settings_tabs $mol_view
			sub /
				<= Interface_settings_link $mol_link
					title \Интерфейс
					arg *
						settings \interface
						help \off
				<= Map_settings_link $mol_link
					title \Настройки карты
					arg *
						settings \map
						help \off
				<= Agent_settings_link $mol_link
					title \Агент
					arg *
						settings \agent
						help \off
				<= Git_settings_link $mol_link
					title \Git-репозитории
					arg *
						settings \git
						help \off
				<= Hotkeys_settings_link $mol_link
					title \Горячие клавиши
					arg *
						settings \hotkeys
						help \off
		^ common_settings_content
	map_settings_content /
		<= Stick_label $mol_labeler
			title \Расстояние прилипания (px)
			Content <= Stick $mol_number
				Inc null
				Dec null
				value? <=> stick_px? 200
		<= Widget_float_resizer_size_label $mol_labeler
			title \Размер ресайзера виджета (px)
			Content <= Widget_float_resizer_size $mol_number
				Inc null
				Dec null
				value? <=> widget_float_resizer_size? 15
		<= Dragger_keep_size_label $mol_labeler
			title \Размер drag-иконки
			Content <= Dragger_keep_size $mol_check_box
				title \Фиксированный
				checked? <=> dragger_keep_size? true
		<= Widget_keyboard_move_step_label $mol_labeler
			title \Шаг перемещения виджетов стрелками (px)
			Content <= Widget_keyboard_move_step $mol_number
				Inc null
				Dec null
				value? <=> widget_keyboard_move_step_px? 1
	hotkeys_settings_content /
		<= Slideshow_mode_label $mol_labeler
			title \Режим просмотра
			content /
				<= Slideshow_mode $mol_string
					value? <=> slideshow_mode_key? \
		<= Fullscreen_disable_label $mol_labeler
			title \Отключить fullscreen
			content /
				<= Fullscreen_disable $mol_string
					value? <=> fullscreen_disable_key? \Escape
		<= Drag_mode_label $mol_labeler
			title \Режим перетаскивания виджетов
			content /
				<= Drag_mode $mol_string
					value? <=> drag_mode_key? \Control
		<= Drawing_mode_label $mol_labeler
			title \Режим рисования
			content /
				<= Drawing_mode $mol_string
					value? <=> drawing_mode_key? \P
	common_settings_content /
		<= Mic_label $mol_labeler
			title \Микрофон
			Content <= Mic $mol_select
				dictionary <= microphones *
				value? <=> mic? \
		<= Overlayed_map_controls $mol_view
			sub /
				<= Overlayed_map_enabled $mol_check_box
					checked? <=> overlayed_map_enabled? false
				<= Overlayed_map_link $mol_link
					title \Overlay-карта
					arg * settings \overlayed_map
		<= Templates_label $mol_labeler
			title \Шаблоны
			Content <= Templates_links $mol_view
				sub /
					<= Template_js_link $mol_link
						title \JS
						arg * settings \templates_js
					<= Template_tsx_link $mol_link
						title \TSX
						arg * settings \templates_tsx
					<= Template_sql_link $mol_link
						title \SQL
						arg * settings \templates_sql
					<= Template_commands_link $mol_link
						title \Команды
						arg * settings \templates_commands
		<= Maps_transfer_label $mol_labeler
			title \Резервная копия карт
			Content <= Maps_transfer $shm_hitalama_settings_transfer
		<= selfhosted_tauri_link
	Catalog $mol_book2_catalog
		param \settings
		Spread_default <= Map_settings
		spread_current => spread_current
		spreads *
			interface <= Interface_settings $shm_hitalama_settings_interface
			map <= Map_settings $mol_page
				title \Настройки карты
				body <= map_settings_content
			agent <= Agent_settings $shm_hitalama_settings_agent
			git <= Git_settings $shm_hitalama_settings_git
			hotkeys <= Hotkeys_settings $mol_page
				title \Горячие клавиши
				body <= hotkeys_settings_content
			templates_js <= Templates_js $shm_hitalama_map_book
				entity <= template_map*js null
			templates_tsx <= Templates_tsx $shm_hitalama_map_book
				entity <= template_map*tsx
			templates_sql <= Templates_sql $shm_hitalama_map_book
				entity <= template_map*sql
			templates_commands <= Templates_commands $shm_hitalama_map_book
				entity <= template_map*commands
			overlayed_map <= Overlayed_map $shm_hitalama_map_book
				entity <= overlayed_map null
			selfhosted_tauri <= Selfhosted_tauri $mol_page
				title \Selfhosted Tauri
				body <= selfhosted_tauri_content /
	Selfhosted_tauri_config $mol_view
		sub <= selfhosted_tauri_config_content
	selfhosted_tauri_config_content /
		^ tauri_port_conflict_message_visible /
			<= Tauri_port_conflict_message $mol_text
				text <= tauri_port_conflict_message \
		<= Tauri_port_label $mol_labeler
			title \Порт
			Content <= Tauri_port $mol_number
				Inc null
				Dec null
				value? <=> tauri_port? 9090
		<= Tauri_domain_label $mol_labeler
			title \Домен
			Content <= Tauri_domain $mol_string
				value? <=> tauri_domain? \
		<= Tauri_master_label $mol_labeler
			title \Master
			Content <= Tauri_master $mol_string
				value? <=> tauri_master? \
		<= Tauri_tunnel_enabled $mol_check_box
			title \SSH-туннель
			checked? <=> tauri_tunnel_enabled? false
		<= Tauri_ssh_host_label $mol_labeler
			title \SSH host
			Content <= Tauri_ssh_host $mol_string
				value? <=> tauri_ssh_host? \
		<= Tauri_ssh_user_label $mol_labeler
			title \SSH user
			Content <= Tauri_ssh_user $mol_string
				value? <=> tauri_ssh_user? \
		<= Tauri_ssh_port_label $mol_labeler
			title \SSH port
			Content <= Tauri_ssh_port $mol_number
				Inc null
				Dec null
				value? <=> tauri_ssh_port? 22
		<= Tauri_remote_port_label $mol_labeler
			title \Remote port
			Content <= Tauri_remote_port $mol_number
				Inc null
				Dec null
				value? <=> tauri_remote_port? 80
		<= Tauri_ssh_key_label $mol_labeler
			title \SSH key path
			Content <= Tauri_ssh_key $mol_string
				value? <=> tauri_ssh_key? \
		<= Tauri_save $mol_button_major
			title \Сохранить
			click? <=> tauri_save? null
		<= Tauri_save_message $mol_text
			text <= tauri_save_message? \
	Selfhosted_tauri_link $mol_link
		title \Selfhosted Tauri
		arg * settings \selfhosted_tauri
	selfhosted_tauri_link null

$shm_hitalama_settings_agent_string $mol_string
	autocomplete_locked? true
	input_name \hitalama_agent_manual
	field *
		^
		autocomplete \off
		readOnly <= autocomplete_locked? true
	attr *
		^
		autocomplete \off
		name <= input_name
		readonly <= autocomplete_locked? true
		aria-autocomplete \none
	event *
		^
		focus? <=> autocomplete_unlock? null

$shm_hitalama_settings_agent_password $mol_password
	input_name \hitalama_agent_secret_manual
	Pass $shm_hitalama_settings_agent_string
		type <= type
		hint <= hint \
		input_name <= input_name
		value? <=> value? \
		submit? <=> submit? null
		enabled <= enabled true
